import { CloseIcon } from 'assets/icons/CloseIcon'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addFoodEmployeeSettings } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex, SquareIcon } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { provisioningModes } from './FoodEligibleEmployees'

export const FoodEmployeeSettingsModal = ({ closeModal, value }: { closeModal: any, value?: IFoodEmployeeSettingsModalState }) => {
    const [state, setState] = useState<IFoodEmployeeSettingsModalState>(value || {
        id: null,
        maxMealsPerOperationalDay: null,
        provisioningMode: null,
        foodSupplier: null,
        selectedMealTypes: [],
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(addFoodEmployeeSettings(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleSelect = (v: ISelectValue, n: string,) => {
        setState(prev => ({ ...prev, [n]: v }))
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const handleMealTypeSelect = (v: ISelectValue, n: string, index: number) => {
        const newMtp = [...state.selectedMealTypes]
        newMtp[index] = v
        setState({ ...state, selectedMealTypes: newMtp })
    }

    const handleAddMealType = () => {
        setState({
            ...state, selectedMealTypes: [
                ...state.selectedMealTypes,
                { label: '', value: null, }
            ]
        })
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Employee Food Settings</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='15' labelText='Maximum amount of meals per day' value={state.maxMealsPerOperationalDay} onChange={e => setState({ ...state, maxMealsPerOperationalDay: e.target.value })} nomarg />
                <HonestSelectInput name='provisioningMode' options={provisioningModes} labelText='Provision Mode' onChange={handleSelect} nomarg defaultValue={state.provisioningMode?.value} required />
                <HonestSelectAsyncInput
                    name='foodSupplier'
                    labelText='Food Supplier'
                    onChange={handleSelect}
                    placeholder='Main Kitchen..'
                    link='food/management/meal/supplier'
                    parserFunction={parse}
                    defaultValue={state.foodSupplier?.label}
                    nomarg
                />
                <Flex column gap='0.5rem' >
                    <TitleText weight='bold' >Meal Types</TitleText>
                    {state.selectedMealTypes?.map((mtp, index) => (
                        <Flex key={index} gap='1rem' >
                            <HonestSelectAsyncInput
                                link='food/management/meal/type'
                                name='mealType'
                                labelText='Type'
                                placeholder='Breakfast...'
                                defaultValue={mtp?.label}
                                onChange={(value, name) => handleMealTypeSelect(value, name, index)}
                                invalid={!mtp?.value}
                                parserFunction={(data: any) => data.data?.map((i: any) => ({ label: i.name, value: i.id }))}
                            />

                        </Flex>
                    ))}
                    <Flex width='100%' end='true' mt='0.5rem' >
                        <SquareIcon onClick={handleAddMealType}>{PlusIcon}</SquareIcon>
                    </Flex>
                </Flex>

            </Flex>
            <Button disabled={!state.provisioningMode?.value} variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IFoodEmployeeSettingsModalState {
    id: number
    provisioningMode?: ISelectValue
    foodSupplier?: ISelectValue
    maxMealsPerOperationalDay: number
    selectedMealTypes: ISelectValue[]
}